import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FeedbackState {
    visible: boolean;
}

const initialState: FeedbackState = {
    visible: false,
};

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState,
    reducers: {
        setFeedbackComponentVisibility(state: FeedbackState, action: PayloadAction<boolean>) {
            state.visible = action.payload;
        },
    },
});

export interface Feedback {
    rating: number;
    reasons?: string[];
    comment?: string;
}

export type FeedbackSubmission = Partial<Feedback>;

export const submitFeedback = createAction<FeedbackSubmission>('@FEEDBACK/SUBMIT_FEEDBACK');

export const { setFeedbackComponentVisibility } = feedbackSlice.actions;

export default feedbackSlice.reducer;
